import React from "react";
import { createPortal } from "react-dom";
import styles from "./DeleteStandardPopUp.module.css";
import deleteIcon from "../../../assets/icons/delete-new-icon.svg";

export default function DeleteStandardPopUp({
  isOpen = false,
  title = "Delete Standard?",
  message = "Are You Sure You Want To Delete This Standard?",
  detail = "By Selecting Delete This Standard Will Be Deleted",
  confirmLabel = "Yes, Delete",
  busyLabel = "Deleting...",
  cancelLabel = "Cancel",
  busy = false,
  errorMessage = "",
  onConfirm,
  onCancel,
}) {
  if (!isOpen || typeof document === "undefined") return null;

  return createPortal(
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label={title}>
      <div className={styles.modal}>
        <div className={styles.iconBadge}>
          <img src={deleteIcon} alt="" aria-hidden="true" className={styles.icon} />
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.message}>{message}</p>
        <p className={styles.detail}>{detail}</p>
        {errorMessage ? <p className={styles.error}>{errorMessage}</p> : null}
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.confirmBtn}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? busyLabel : confirmLabel}
          </button>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={onCancel}
            disabled={busy}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

